module.exports = __webpack_public_path__ + "img/hair_front_female_hairline_mask.01710ca0.png";